"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LftListMenu_styles_1 = require("./LftListMenu.styles");
var use_key_press_1 = require("../../utils/hooks/use-key-press");
var menuRef = (0, react_1.createRef)();
var LftListMenu = function (_a) {
    var _b = _a.ariaLabel, ariaLabel = _b === void 0 ? 'listbox' : _b, bgColor = _a.bgColor, children = _a.children, dataTestId = _a.dataTestId, id = _a.id, required = _a.required, tabindex = _a.tabindex, _c = _a.visible, visible = _c === void 0 ? false : _c, lftChange = _a.lftChange, lftClose = _a.lftClose, _d = _a.positionTop, positionTop = _d === void 0 ? '40px' : _d;
    var _e = (0, react_1.useState)(visible), menuVisible = _e[0], setMenuVisible = _e[1];
    var _f = (0, react_1.useState)(), selectedItem = _f[0], setSelectedItem = _f[1];
    var _g = (0, react_1.useState)(0), focusedItem = _g[0], setFocusedItem = _g[1];
    var _h = (0, react_1.useState)([]), itemsList = _h[0], setItemsList = _h[1];
    var downPress = (0, use_key_press_1.useKeyPress)('ArrowDown', menuRef);
    var upPress = (0, use_key_press_1.useKeyPress)('ArrowUp', menuRef);
    var escapePress = (0, use_key_press_1.useKeyPress)('Escape', menuRef);
    //Controlo através desta função o fechamento do menu
    var _handleOnClose = (0, react_1.useCallback)(function () {
        var status = !menuVisible;
        setMenuVisible(status);
        setFocusedItem(0);
        lftClose &&
            lftClose({
                visible: status,
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _handleOnChange = (0, react_1.useCallback)(function (e) {
        lftChange && lftChange(e);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //Controlo através desta função os clicks dos elementos filhos
    var _handleOnClick = (0, react_1.useCallback)(function (e) {
        setSelectedItem({
            value: e.detail.value,
            currentIndex: Number(e.detail.index),
        });
    }, []);
    //Busco e defino o focus na children dentro do elemento pai através do item que está focado no momento.
    (0, react_1.useEffect)(function () {
        if (menuRef.current) {
            var currentRef = menuRef.current;
            var childrenArray = currentRef.querySelectorAll('li');
            if (childrenArray && childrenArray.length > 0) {
                try {
                    childrenArray[focusedItem].focus();
                }
                catch (error) { }
            }
        }
    }, [focusedItem]);
    //Devolvo no evento, o valor atual selecionado
    (0, react_1.useEffect)(function () {
        if (selectedItem) {
            setFocusedItem(selectedItem.currentIndex);
            _handleOnChange({
                value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value,
                currentIndex: selectedItem.currentIndex,
            });
            _handleOnClose();
        }
    }, [selectedItem, _handleOnClose, _handleOnChange]);
    //Clono os elementos filhos, passando novos parametros.
    (0, react_1.useEffect)(function () {
        var childrenWithNewProps = react_1.Children.map(children, function (child, index) {
            return (0, react_1.isValidElement)(child)
                ? (0, react_1.cloneElement)(child, { key: index, bgColor: bgColor, lftClick: _handleOnClick, index: index })
                : child;
        });
        if (childrenWithNewProps) {
            setItemsList(childrenWithNewProps);
        }
    }, [children, _handleOnClick]);
    //Controlo o evento de keydown
    (0, react_1.useEffect)(function () {
        if (itemsList && itemsList.length && downPress) {
            setFocusedItem(function (prevState) { return (prevState < itemsList.length - 1 ? prevState + 1 : prevState); });
        }
    }, [downPress, itemsList]);
    //Controlo o evento de keyup
    (0, react_1.useEffect)(function () {
        if (itemsList && itemsList.length && upPress) {
            setFocusedItem(function (prevState) { return (prevState > 0 ? prevState - 1 : prevState); });
        }
    }, [upPress, itemsList]);
    //Controlo o evento de tab
    (0, react_1.useEffect)(function () {
        if (escapePress) {
            _handleOnClose();
        }
    }, [escapePress, _handleOnClose]);
    //Recebo e atualizo caso o parametro opened seja atualizado
    (0, react_1.useEffect)(function () {
        setMenuVisible(visible);
    }, [visible]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !!menuVisible && ((0, jsx_runtime_1.jsx)(LftListMenu_styles_1.ListMenuStyled, __assign({ "aria-label": ariaLabel, "aria-readonly": "true", "aria-required": !!required, bgColor: bgColor, "data-lift": "lft-listmenu", "data-testid": dataTestId ? dataTestId : id && id, id: id, ref: menuRef, role: "listbox", tabIndex: tabindex, positionTop: positionTop }, { children: itemsList }), void 0)) }, void 0));
};
exports.default = LftListMenu;
